// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"9178f717","455":"f7a829bd","977":"1cd50b2d"}[chunkId] + ".chunk.js";
};